export default {
  "titles": {
    "editProfile": "Editar Perfil"
  },
  "detail": {
    "email": "Correio (nome de usuário)",
    "permits": "Permissões",
    "categories": "Categorias",
    "isAdmin": "Administrador - Todas as permissões",
    "editData": "Editar dados",
    "linkToWearable": "Pulseiras de sonho",
    "resetPassword": "Redefinir senha",
    "linkToFitbit": "Conectar Fitbit",
    "unLinkToFitbit": "Desconectar Fitbit",
    "fitbitState": "Estado Fitbit",
    "connect": "Conectado",
    "disconnect": "Desconectado",
    "tours": "Passeios",
    "resetTours": "Redefinir passeios"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/user_profile/index.js